import { Component, HostBinding } from '@angular/core';
import {
	ActivatedRoute,
	GuardsCheckEnd,
	GuardsCheckStart,
	NavigationCancel,
	NavigationEnd,
	NavigationError,
	NavigationStart,
	ResolveEnd,
	ResolveStart,
	Router,
} from '@angular/router';
import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';
import { SharedStore } from './core/providers/shared';



@Component({
	// tslint:disable-next-line:component-selector
	selector:		'app',
	templateUrl:	'app.html',
})
export class AppComponent {
	public loadInProgress: boolean = false;



	constructor(
		router: Router,
		angulartics2GoogleTagManager: Angulartics2GoogleTagManager,
		public shared: SharedStore,
	) {
		router.events.subscribe((event) => {
			if (event instanceof NavigationStart) {
				console.log('AppComponent', 'NavigationStart', event);

				this.loadInProgress = true;

			} else if (event instanceof GuardsCheckStart) {
				// console.log(event);
			} else if (event instanceof GuardsCheckEnd) {
				// console.log(event);
			} else if (event instanceof ResolveStart) {
				// console.log(event);
			} else if (event instanceof ResolveEnd) {
				// console.log(event);
			} else if (event instanceof NavigationEnd) {
				console.log('AppComponent', 'NavigationEnd', event);

				this.loadInProgress	= false;

			} else if (event instanceof NavigationCancel) {
				console.log('AppComponent', 'NavigationCancel', event);

				this.loadInProgress = false;

			} else if (event instanceof NavigationError) {
				console.log('AppComponent', 'NavigationError', event);

				this.loadInProgress = false;
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/app.ts